import React, { useState } from 'react';
import { Navbar, Nav, Container, Button, NavDropdown } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MapPin, Building2, Factory, Landmark } from 'lucide-react';

const AppNavbar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showChapters, setShowChapters] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const showDropdown = () => {
        setShowChapters(true);
    };

    const hideDropdown = () => {
        setShowChapters(false);
    };

    const closeNavbar = () => {
        setExpanded(false);
    };

    const handleNavClick = () => {
        closeNavbar();
    };

    return (
        <Navbar expand="lg" fixed="top" className="py-3 navbar-custom" expanded={expanded} onToggle={setExpanded}>
            <Container>
                <Navbar.Brand as={Link} to="/" className="fw-bold d-flex align-items-center" onClick={handleNavClick}>
                    <img src="/assets/images/lbo-logo.png" alt="LBO Logo" height="50" className="me-2 d-none d-sm-block" style={{ maxHeight: '50px', width: 'auto' }} />
                    <img src="/assets/images/lbo-logo.png" alt="LBO Logo" height="40" className="me-2 d-block d-sm-none" style={{ maxHeight: '40px', width: 'auto' }} />
                    <span className="text-dark d-none d-lg-inline" style={{ fontSize: '0.9rem', opacity: 0.75, borderLeft: '2px solid #ddd', paddingLeft: '0.75rem' }}>Lingayat Business Organization</span>
                    <span className="text-dark d-none d-md-inline d-lg-none" style={{ fontSize: '0.85rem', opacity: 0.75, borderLeft: '2px solid #ddd', paddingLeft: '0.5rem' }}>LBO</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0 shadow-none" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto align-items-center">
                        <Nav.Link as={Link} to="/" className="nav-link-custom" active={location.pathname === '/'} onClick={handleNavClick}>Home</Nav.Link>
                        <Nav.Link as={Link} to="/about" className="nav-link-custom" active={location.pathname === '/about'} onClick={handleNavClick}>About</Nav.Link>
                        <Nav.Link as={Link} to="/services" className="nav-link-custom" active={location.pathname === '/services'} onClick={handleNavClick}>Services</Nav.Link>

                        <NavDropdown
                            title={<span onClick={() => { navigate('/chapters'); handleNavClick(); }}>Chapters</span>}
                            id="chapters-dropdown"
                            className="nav-link-custom"
                            show={showChapters}
                            onMouseEnter={showDropdown}
                            onMouseLeave={hideDropdown}
                        >
                            <NavDropdown.Item as={Link} to="/chapters/sangli" style={{ fontSize: '1.05rem' }} onClick={handleNavClick}>
                                <MapPin size={20} className="me-2" style={{ display: 'inline-block', verticalAlign: 'middle', color: '#3b82f6' }} />
                                Sangli Chapter
                            </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/chapters/kolhapur" style={{ fontSize: '1.05rem' }} onClick={handleNavClick}>
                                <Building2 size={20} className="me-2" style={{ display: 'inline-block', verticalAlign: 'middle', color: '#8b5cf6' }} />
                                Kolhapur Chapter
                            </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/chapters/ichalkaranji" style={{ fontSize: '1.05rem' }} onClick={handleNavClick}>
                                <Factory size={20} className="me-2" style={{ display: 'inline-block', verticalAlign: 'middle', color: '#f97316' }} />
                                Ichalkaranji Chapter
                            </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/chapters/solapur" style={{ fontSize: '1.05rem' }} onClick={handleNavClick}>
                                <Landmark size={20} className="me-2" style={{ display: 'inline-block', verticalAlign: 'middle', color: '#10b981' }} />
                                Solapur Chapter
                            </NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Link as={Link} to="/members" className="nav-link-custom" active={location.pathname === '/members'} onClick={handleNavClick}>Members</Nav.Link>
                        <Nav.Link as={Link} to="/events" className="nav-link-custom" active={location.pathname === '/events'} onClick={handleNavClick}>Events</Nav.Link>
                        <Nav.Link as={Link} to="/contact" className="nav-link-custom" active={location.pathname === '/contact'} onClick={handleNavClick}>Contact</Nav.Link>
                        <Button as={Link} to="/contact" state={{ type: 'join_lbo' }} variant="primary" className="ms-lg-3 px-4 rounded-pill btn-hover-effect fw-medium" onClick={handleNavClick}>
                            Join LBO
                        </Button>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AppNavbar;
